import { useSelector } from 'react-redux';
import { RootStateType } from '#components/redux/types';

const useAppSelector = useSelector.withTypes<RootStateType>();

export { useAppSelector };
